import DiamondSvgSrc from "@icons/diamond-cta.svg?url";
import { Trans } from "@lingui/react/macro";

import {
  Button,
  PlanUpgradeCta,
} from "@/routes/shared/components/plan-upgrade-cta/plan-upgrade-cta";

const CallToAction = ({ onClick }: { onClick: () => void }) => {
  return (
    <PlanUpgradeCta
      description={
        <Trans>
          Ceny garantované obchodníky, kteří vkládají cenu do systému.
        </Trans>
      }
      heading={<Trans>Toto jsou zázvazné ceny vstupů.</Trans>}
      icon={
        <img
          className="h-12 w-12 sm:h-6 sm:w-6 @max-sm:h-12 @max-sm:w-12"
          src={DiamondSvgSrc}
        />
      }
    >
      <Button onClick={onClick}>
        <Trans>Chci nakupovat</Trans>
      </Button>
    </PlanUpgradeCta>
  );
};

export { CallToAction };
